import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Loader } from "react-loaders";
import LoadingOverlay from "react-loading-overlay-ts";
import cx from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import Header from "../Layout/AppHeader";
import Footer from "../Layout/AppFooter";
import AppSidebar from "../Layout/AppSidebar";
import { getHeaderNotification, getSessionValue, constructEmitStr, logoutUser, parseJSON, setSessionValue, confirmBoxWithImage, getLicenseInformations, setCookie, getCookie, getAppType, checkIsPageNotFound, getGeneralSettings, showToast } from "./Appcommon";
import { SocketProvider, socket } from "../Components/Inbox/context/socketContext";
import ChangePwd from "../Components/ChangePwd";
import { setAppCustomTitle } from "../reducers/ThemeOptions";
import noAccessImag from "../assets/utils/images/403.jpg";
import requestApi from '../services/requestApi.service';
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import Chat from '../Layout/Chat';
import { PopupProvider } from './context/popupContext';
import Popup from './Popup';
import CTCLogo from '../Layout/CTCLogo';
import WelcomePopup from '../Layout/WelcomePopup';
import ProvidersWrapper from '../Components/Inbox/context/ProvidersWrapper';
import { SSEProvider } from '../Components/Inbox/context/SSEProvider';
import { faPhoneVolume } from "@fortawesome/free-solid-svg-icons";


function Common(props) {
    let pageTitle = props.pageTitle !== undefined && props.pageTitle != null ? "Cratio - " + props.pageTitle : "";
    const [notification, setNotification] = useState({ show: false });
    const [isRedirectNeeded, setIsRedirectNeeded] = useState(false);
    const isFirstTimeLogin = getSessionValue('isFirstTimeLogin');
    const changePwd = getSessionValue('changePwd');
    const [toggleIframeModal, setToggleIframeModal] = useState(false);
    const iframeRef = useRef(null);
    const appid = getSessionValue('appid');
    const isNeedIframePopup = getSessionValue("NEED_CTC_POPUP") === "Yes" ? true : false;
    const isNeedChatWidget = getSessionValue("NEED_OZ_CHAT_POPUP") === "Yes" ? true : false;
    const incomingCallAlert = getSessionValue("NEED_INCOMING_CALL_ALERT") === "Yes" ? true : false;
    const isadmin = getSessionValue('isadmin') === "Yes" ? true : false;
    const isNeedCTCWidget = getSessionValue("NEED_ASTER_CALL_POPUP") === "Yes" ? true : false;
    const popupCustomURL = getSessionValue("NEED_POPUP_CUSTOM_URL");
    const popupURL = popupCustomURL != "" ? popupCustomURL : "https://crm-app.doocti.com";
    let socketType = process.env.REACT_APP_SOCKET_TYPE;
    const [isDisableRightClickNeeded, setIsDisableRightClickNeeded] = useState("");
    const [isIframeVisible, setIsIframeVisible] = useState(false);
    const [isCTEnabled, setIsCTEnabled] = useState(false);
    const hiddenIframeRef = useRef(null);
    const [lastCallData, setLastCallData] = useState(null);
    useEffect(() => {
        document.title = pageTitle;
        if (isNeedIframePopup) {
            getCTDetails();
            window.addEventListener('message', handleMessage);
        }
        let isPageNotFound = checkIsPageNotFound();
        if (isPageNotFound) {
            setIsRedirectNeeded(isPageNotFound);
            return;
        }
        async function getNotification() {
            let headernotification = await getHeaderNotification();
            setNotification(headernotification);
        }
        setAppCustomTitle(getSessionValue('appTitle'));
        getNotification();
        if (process.env.REACT_APP_IS_NEW_PAYMENT === "true") {
            checkLicenseIsValid();
        }
        async function getDisableRightNeeded() {
		//alert("HERE 1");
            let setting = await getGeneralSettings("DISABLE_RIGHT_CLICK_GLOBALLY",true);
            setIsDisableRightClickNeeded(setting == "" || setting == null || setting == undefined ? false : true);
        }
        getDisableRightNeeded();
    }, []);
    useEffect(() => {
        const savedCall = localStorage.getItem("ctc_call_state");
        if (savedCall) {
            try {
                const parsed = JSON.parse(savedCall);
                if (parsed?.type === "Ringing" || parsed?.type === "OnCall") {
                    setLastCallData(parsed);
                }
            } catch (e) {
                console.error("Invalid saved call state");
            }
        }
    }, []);
    useEffect(() => {
        if (socket) {
            socket.on(constructEmitStr(appid, '', "wplogout"), logoutUser);
        }
    }, [socket]);

    useEffect(() => {
        const disableRightClick = (event) => {
            event.preventDefault();
            alert("Right-click is restricted.");
        };

        // Check if setting is a non-empty array
        if (isDisableRightClickNeeded != "") {
            document.addEventListener("contextmenu", disableRightClick);
        } else {
            document.removeEventListener("contextmenu", disableRightClick);
        }
        return () => {
            document.removeEventListener("contextmenu", disableRightClick);
        };
    }, [isDisableRightClickNeeded]); // Runs when setting changes

    const openFilterModal = () => {
        setIsIframeVisible(true);
        //openModalPanel();
    };
    const closeFilterModal = () => {
        setIsIframeVisible(false);
        //closeModalPanel();
    };
    /*const openModalPanel = () =>{
        const outermostDiv = document.querySelector('[style="position: relative; z-index: 1050; display: none;"]');
        if(outermostDiv !== null){
            outermostDiv.style.display = 'block';
        }
    }
    const closeModalPanel = () =>{
        const soutermostDiv = document.querySelector('[style="position: relative; z-index: 1050; display: block;"]');
        if(soutermostDiv !== null){
            soutermostDiv.style.display = 'none';
        }
    }*/
    const handleMessage = (event) => {
        if (isNeedIframePopup) {
            // Check if the message is from a trusted source if necessary
            // For example, you might check event.origin
            // Access the data sent with postMessage
            //if(event.origin === process.env.REACT_APP_SERVER_URL){
            let messageData = event.data;
            if (typeof messageData === "string") {
                messageData = JSON.parse(messageData);
            }  
            if (messageData?.type === "Hangup" || messageData?.type === "CallEnded") {
                 setLastCallData(null);
                 localStorage.removeItem("ctc_call_state");
            }
            if (messageData?.type === "Ringing" || messageData?.type === "OnCall") {
                setLastCallData(messageData);
                localStorage.setItem("ctc_call_state", JSON.stringify(messageData));
                setIsIframeVisible(true);
                setTimeout(() => {
                    if (iframeRef.current) {
                        iframeRef.current.contentWindow.postMessage(messageData, "*");
                    }
                }, 500);
            }
            if ((messageData['tenant_id'] !== undefined && messageData['tenant_id'] !== "") || (messageData['type'] && messageData['type'] === 'Ringing')) {
                setLastCallData(messageData);
                setIsIframeVisible(true);
                localStorage.setItem("ctc_call_state", JSON.stringify(messageData));
                openFilterModal();
                setTimeout(() => {
                    const iframeWidget = iframeRef.current  || hiddenIframeRef.current;
                    if (iframeWidget) {
                        console.log("messageData: ",messageData);
                        iframeWidget.contentWindow.postMessage(messageData, "*");
                        if(popupCustomURL){
                            getCustomUserDetails(messageData['user_number'],messageData['entity_number']);
                        }
                    }
                }, 1000);
            }
            //} else {
            //console.log('Custom Receive DATA:', event.data);
            // }
        }
    };

    let loaderType = "ball-spin-fade-loader";
    let customClass = props.customClass !== undefined && props.customClass != null ? props.customClass : "";

    const oncloseAction = () => {
        setNotification(false);
    }
    const getCustomUserDetails = async (from,to) => {
       
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION" : 'PushCustomCTCDetails',
            "from" : from,
            "to" : to            
        }
        let res = await requestApi.processServerRequest(params, "web");
        if(res.issuccess && !res.data.status){
            showToast(res.data.message, "top-right", "error");    
        }
       
    }
    const checkLicenseIsValid = async () => {
        const curURL = window.location.hash;
        if (curURL !== "#/subscription" && !(curURL.indexOf("#/settings") > 0)) {
            const licenseValidate = parseJSON(getSessionValue('licenseValidate'));
            let typeOfError = licenseValidate[0];
            let header = licenseValidate[1];
            let message = licenseValidate[2];
            let isSubscription = licenseValidate[3];
            /*
            *   type is a if condition based
            *   0 - 0 to 3 days remainder
            *   1 - Already Expired
            *   2 - Halted Time
            */
            let cancel = {
                text: isSubscription ? "Later" : "Pay Later",
                value: false,
                visible: true,
                className: "",
                closeModal: true,
            };
            let confirm = {
                text: isSubscription ? "Subscribe Now" : "Pay Now",
                value: true,
                visible: true,
                className: "",
                closeModal: true
            };
            if (typeOfError === 0 && isadmin & !isSubscription) {
                // last 3 days in license ending
                let paymentLater = getCookie("paymentLater");
                if (paymentLater === null || paymentLater !== "true") {
                    let isConfirm = await confirmBoxWithImage(header, message, "", "", "", cancel, confirm, false, false);
                    if (isConfirm) {
                        window.location.href = '/#/subscription'
                    } else {
                        setCookie("paymentLater", "true", 1, "", 0, 0, 0);
                    }
                }
            } else if (typeOfError === 1) {
                // license expired
                cancel.visible = true;
                cancel.text = "Go to Settings";
                if (!isadmin) {
                    confirm.visible = false;
                }
                confirm.text = "Subscribe Now";
                header = "Your subscription has ended"
                message = "Your CRM account subscription is inactive. To resume access, please select a plan and renew your subscription."
                let isConfirm = await confirmBoxWithImage(header, message, "", "", "", cancel, confirm, false, false);
                if (isConfirm) {
                    window.location.href = '/#/subscription';
                } else {
                    window.location.href = '/#/settings';
                }
            } else if ((typeOfError === 2 || typeOfError === 3) && isadmin && isSubscription) {
                // halted time
                cancel.visible = false;
                cancel.text = "Ok";
                confirm.text = "Ok";

                if (getCookie("haltedBtnClicked") !== "true") {
                    let isConfirm = await confirmBoxWithImage(header, message, "", "", "", cancel, confirm, false, false);
                    if (isConfirm) {
                        setCookie("haltedBtnClicked", "true", 1, "", 0, 0, 0);
                    }
                }
            }
        }
    }
    const getCTDetails = async (e) => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION" : 'getCustomFeature',
            "index" : "18",
        }
        let response = await requestApi.processServerRequest(params, "WebV2", "get", false);
            if (response.issuccess) {
                if(response.data != ""){
                    setIsCTEnabled(true);
                }else{
                    setIsCTEnabled(false);
                };
        }
    }
    const downloadPi = async (e) => {
        let params = {
            "ENTITY": "PRINT_PI",
        }
        let response = await requestApi.processServerRequest(params, "WebV2", "get", false);
        if (response.issuccess) {
            let data = response.data;
            window.open(data, "_blank");
        }
    }

const handleOpenCTC = () => {
    setIsIframeVisible(true);

    const savedCall = localStorage.getItem("ctc_call_state");
    let callData = null;

    try {
        callData = savedCall ? JSON.parse(savedCall) : lastCallData;
    } catch (e) {
        callData = lastCallData;
    }

    // 🔥 Ensure iframe is ready
    setTimeout(() => {
        const iframe = iframeRef.current;

        if (iframe && callData) {
            iframe.onload = () => {
                console.log("Restoring call after refresh:", callData);
                iframe.contentWindow.postMessage(callData, "*");
            };
        }
    }, 300);
};
    const changePassword = (isFirstTimeLogin == "true" || changePwd == "true");

    return (
        <Fragment>
            <div className={cx('header-notification', {
                'hide': !notification.show
            })}>
                <div className={'header-notification-body'}>
                    <>
                        {notification.icon && <FontAwesomeIcon icon={faCircleInfo} />}
                        {notification.text}
                        {notification.btnShow && <button type="button" className='header-notification-button' aria-label="Download PI" onClick={(e) => { downloadPi(e) }} > {notification.btnText} </button>}
                    </>
                </div>
                <button type="button" className="btn-close" aria-label="Close" onClick={(e) => { oncloseAction(e) }} ></button>

            </div>
            <Header />
            {isNeedChatWidget &&
                <Chat />}
            {isNeedCTCWidget &&
                <CTCLogo />}
            {incomingCallAlert && socketType === "A" &&
                <SocketProvider>
                    <PopupProvider>
                        <Popup isInbox={true}></Popup>
                    </PopupProvider>
                </SocketProvider>
            }
            {incomingCallAlert && socketType === "B" &&
                <ProvidersWrapper usePopup={true}>
                    <SSEProvider>
                        <Popup isInbox={true}></Popup>
                    </SSEProvider>
                </ProvidersWrapper>
            }
            <div className={cx(`app-main`, {
                'notification-enabled': notification.show,
                'notification-not-enabled': !notification.show
            })}>
                <AppSidebar />
                <div className="app-main__outer">
                    <WelcomePopup />
                    <LoadingOverlay tag="div" active={props.showLoader}
                        styles={{
                            overlay: (base) => ({
                                ...base,
                                background: "#fff",
                                opacity: 0.5,
                                color: "red"
                            }),
                        }}
                        spinner={<Loader active={props.showLoader} type={loaderType} />}><div className={`app-main__inner bg-white ${customClass} ${isRedirectNeeded && "access-restricted"}`}>
                            {!isRedirectNeeded ? props.mainContent : <img src={noAccessImag} alt={"Forbidden"}></img>}
                            {changePassword && < ChangePwd isClearable={changePwd == "true" ? true : false} />}
                        </div>
                    </LoadingOverlay>
                    {/* {isNeedIframePopup && !isIframeVisible  && !popupCustomURL && isCTEnabled && (
                        <iframe
                            ref={hiddenIframeRef}
                            id="hidden-ctc-iframe"
                            src={popupURL}
                            style={{
                                position: "absolute",
                                width: 0,
                                height: 0,
                                border: 0,
                                visibility: "hidden"
                            }}
                        />

                    )} */}
                    {/* {isNeedIframePopup && !popupCustomURL && isCTEnabled && (                        
                        <div
                            style={{
                                position: "fixed",
                                bottom: "80px",
                                right: "140px",
                                display: "flex",
                                flexDirection: "column",
                                gap: "10px",   // spacing between icons
                                zIndex: 9999
                            }}
                        >
                            
                            <div
                                 onClick={handleOpenCTC}
                                style={{
                                    width: "55px",
                                    height: "55px",
                                    borderRadius: "50%",
                                    backgroundColor: "#28a745",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                    cursor: "pointer"
                                }}
                            >
                                <FontAwesomeIcon icon={faPhoneVolume} style={{ fontSize: "20px", color: "#fff" }} />
                            </div>
                        </div>
                    )} */}
                    {isNeedIframePopup &&
                        <Modal zIndex={toggleIframeModal ? 1050 : 1540} modalClassName={ popupCustomURL ? 'modal-classtest': ''} wrapClassName={'test-wrapper'} isOpen={isIframeVisible}
                            className={cx('modal-lg lg-iframe-modal')}  toggle={() => setIsIframeVisible(false)} unmountOnClose={false}  >
                            <ModalHeader
                                toggle={closeFilterModal}>Click to Call Infomation</ModalHeader>
                            <ModalBody>
                                <iframe ref={iframeRef} allow="camera *; geolocation *; microphone *; autoplay *; display-capture *" id="lg-ctc-iframe" height="100%" width="100%" src={popupURL} />
                            </ModalBody>
                        </Modal>
                    }
                    <Footer pageTitle={pageTitle} />
                </div>
            </div>

        </Fragment>
    );
}

export default Common;
